import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { VehicleConformityDetailsDto, VehicleConformityDOTRejectionDto, VehicleConformitySendBackToCanadaDto } from 'dtos/vehicles/conformity'
import { VehicleConformityDto } from 'dtos/vehicles/conformity/VehicleConformityDto'
import { objectToFormData } from 'utils'

const baseUrl = (vehicleGuid: string): string => `/api/vehicles/${encodeURIComponent(vehicleGuid)}/conformity`

export const getConformity = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<VehicleConformityDto>>(baseUrl(vehicleGuid), { cancelToken }).then(res => res.data)

export const getConformityDetails = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<VehicleConformityDto>>(`${baseUrl(vehicleGuid)}/details`, { cancelToken }).then(res => res.data)

export const updateConformityDetails = (vehicleGuid: string, values: VehicleConformityDetailsDto, cancelToken?: CancelToken) =>
  apiClient.put<ApiResponse<VehicleConformityDto>>(`${baseUrl(vehicleGuid)}/details`, values, { cancelToken }).then(res => res.data)

export const getDOTRejection = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<VehicleConformityDto>>(`${baseUrl(vehicleGuid)}/dot-rejection`, { cancelToken }).then(res => res.data)

export const updateDOTRejection = (vehicleGuid: string, values: VehicleConformityDOTRejectionDto, cancelToken?: CancelToken) =>
  apiClient<ApiResponse<VehicleConformityDto>>({
    cancelToken,
    data: objectToFormData(values),
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `${baseUrl(vehicleGuid)}/dot-rejection`
  }).then(res => res.data)

export const getSendBackToCanada = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<VehicleConformitySendBackToCanadaDto>>(`${baseUrl(vehicleGuid)}/send-back-to-canada`, { cancelToken }).then(res => res.data)

export const updateSendBackToCanada = (vehicleGuid: string, values: VehicleConformitySendBackToCanadaDto, cancelToken?: CancelToken) =>
  apiClient
    .put<ApiResponse<VehicleConformityDto>>(`${baseUrl(vehicleGuid)}/send-back-to-canada`, values, {
      cancelToken
    })
    .then(res => res.data)
